// Formats a duration in seconds as a compact "Xm Ys" (or "Xm") label.
// `zeroLabel` is returned for falsy/zero input so callers can choose between an
// empty string (hide the label) and an explicit "0m".
export function formatDuration(seconds, { zeroLabel = '' } = {}) {
  if (!seconds) return zeroLabel
  const total = Math.round(seconds)
  const minutes = Math.floor(total / 60)
  const remainingSeconds = total % 60
  return remainingSeconds > 0 ? `${minutes}m ${remainingSeconds}s` : `${minutes}m`
}
